<div class="cet-otp-input-container">
  <input
    type="number"
    *ngFor="let input of [].constructor(length); let i = index"
    (input)="onInput(i, $event)"
    (keyup.backspace)="emitOrPrev(i)"
    placeholder=" "
    (paste)="onPaste(i, $event)"
    autocomplete="off"
    [id]="'cet-otp-' + i"
    [disabled]="readonly"
  />
</div>
